import React, { useMemo } from "react";
import Dropdown from "../DropDown";

interface ResourceDropdownProps {
  selectedResource: string;
  resources: any[];
  onResourceChange: (selectedResource: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const ResourceDropdown: React.FC<ResourceDropdownProps> = ({
  selectedResource,
  resources,
  onResourceChange,
  disabled,
  className = "",
  onFocus,
}) => {

  const options = useMemo(() => {
    const map = new Map<string, boolean>();
  
    resources.forEach((asset: any) => {
      asset.resources?.forEach((r: any) => {
        if (r.iso_resource_name) {
          map.set(r.iso_resource_name, true);
        }
      });
    });
  
    return Array.from(map.keys())
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" })) // A–Z, case-insensitive
      .map((name) => ({
        value: name,
        label: name,
      }));
  }, [resources]);
  
  

  return (
    <Dropdown
      options={options}
      selectedValue={selectedResource}
      onValueChange={onResourceChange}
      disabled={disabled}
      className={className}
      placeholder="Select Resource"
      onFocus={onFocus}
    />
  );
};

export default ResourceDropdown;
